import {
  GET_LATEST_LEAGUE_SMP_LOADING,
  GET_LATEST_LEAGUE_SMP_SUCCESS,
  GET_LATEST_LEAGUE_SMP_ERROR,
} from "../../../constant/actionTypes";

const smpLeagueReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_LATEST_LEAGUE_SMP_LOADING: {
      let obj = {
        loading: true,
      };
      return obj;
    }
    case GET_LATEST_LEAGUE_SMP_SUCCESS: {
      let obj = {
        loading: false,
        status: action.response,
      };
      return obj;
    }
    case GET_LATEST_LEAGUE_SMP_ERROR: {
      let obj = {
        loading: false,
        status: action.response,
      };
      return obj;
    }
    default:
      return state;
  }
};

export default smpLeagueReducer;
